import { ICreateOrderResponse } from '@/api/api.interface'
import { ENV_CONFIG } from '@/constants/envs/constants'
import { ChainId } from '@/lib/chain'
import { Native, SerializedCryptoType } from '@/lib/cryptoCurrency'
import { FiatCurrency } from '@/lib/fiatCurrency'
import { SerializedFait } from '@/lib/fiatCurrency/zod'
import { TTradeBookHistoryResponse } from '@/pages/TradeHistory/TradeHistoryType'
import { safeLocalStorage } from '@/utils'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Address, Chain } from 'viem'
import { TradeSide } from '@/hooks/types'

export interface ITradeBookHistoryData {
  side: TradeSide
  chainId: number
  txHash: string
  recipientWalletAddress: string
  payFiatCurrencyAmount: string
  payFiatCurrencySymbol: string
  toCryptoCurrencyAmountBase: string
  toCryptoCurrencyAddress: string
  toCryptoCurrencySymbol: string
  orderDisplayId: string
  paymentAt: string
  tradeBookCompletedAt: string
}

export interface ITradeHistoryState {
  readonly tradeBookHistory: ITradeBookHistoryData[] | null
}

const initialState: ITradeHistoryState = {
  tradeBookHistory: null
}

const tradeHistorySlice = createSlice({
  name: 'tradeHistory',
  initialState,
  reducers: {
    setTradeHistory(state, action: PayloadAction<ITradeBookHistoryData[]>) {
      state.tradeBookHistory = action.payload
    },

    clearTradeHistory: () => {
      return initialState
    }
  }
})

export const { setTradeHistory, clearTradeHistory } = tradeHistorySlice.actions
export default tradeHistorySlice.reducer
